import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

import {map, tap} from 'rxjs/operators';
import {environment} from '~/environments/environment';
import {BaseService} from "~/app/core/services/base.service";

const CREATE_ACTION = 'create';
const UPDATE_ACTION = 'update';
const REMOVE_ACTION = 'destroy';
const RETRIEVE_ITEMS_GL_LIST = 'itemsgllist';
const UPDATE_ITEMS_GL_LIST = 'updateglitem';


@Injectable({
  providedIn: 'root'
})
export class EditService extends BehaviorSubject<any[]> {
  public hoId: string = '';

  readonly RESTPATH = '/fs-online-invoicing-ws/rest/v1';
  //readonly RESTURL = this.BASEURL + this.RESTPATH;
  readonly RESTURL = environment.base_url + this.RESTPATH + '/itemgl/';

  constructor(private baseService: BaseService) {
    super([]);
  }

  private data: any[] = [];


  public read(hoId: string) {
    this.hoId = hoId;
    if (this.data.length) {
      return super.next(this.data);
    }

    this.fetch(RETRIEVE_ITEMS_GL_LIST, this.hoId)
      .pipe(
        tap(data => {
          console.log('welp...');
          console.log(data);
          this.data = data;
        })
      )
      .subscribe(data => {
        super.next(data);
      });
  }

  public save(data: any, isNew?: boolean): Observable<any> {
    // public save(data: any, isNew?: boolean) {
    //   const action = isNew ? CREATE_ACTION : UPDATE_ITEMS_GL_LIST;

    this.reset();


    console.warn(this.RESTURL + UPDATE_ITEMS_GL_LIST, this.serializeModels(data));
    return this.baseService.putHttpObject<any>(
      'updateGLitem',
      'edit-service',
      this.RESTURL + UPDATE_ITEMS_GL_LIST, this.serializeModels(data))
      .pipe(

      );
    // TODO call update
    // this.fetch(action, data)
    //   .subscribe(() => this.read(this.hoId), () => this.read(this.hoId));
  }

  public remove(data: any) {
    this.reset();

    this.fetch(REMOVE_ACTION, data)
      .subscribe({ next: () => {this.read(this.hoId), () => this.read(this.hoId)}});
  }

  public resetItem(dataItem: any) {
    if (!dataItem) {
      return;
    }

    // find orignal data item
    const originalDataItem = this.data.find(item => item.glCode != undefined ? item.glCode : '' === dataItem.glCode != undefined ? dataItem.glCode : '');

    // revert changes
    Object.assign(originalDataItem, dataItem);

    super.next(this.data);
  }

  private reset() {
    this.data = [];
  }


  private fetch(action: string = '', data?: any): Observable<any[]> {
    console.warn('Fetching...  Action=' + action + ' - ' + ' Data=' + data);

    // if (action === UPDATE_ITEMS_GL_LIST) {
    //   return this.http
    //     .put(`https://fsconnect-test.mclaneco.com/fs-online-invoicing-ws/rest/v1/itemgl/${action}`, this.serializeModels(data)})
    //     .pipe(map(res => <any[]>res));
    //
    //
    //   // console.warn(this.configuration.RESTURL + action, itemList);
    //   // return this.http.put<any>(this.configuration.RESTURL + '/itemgl/' + action, this.serializeModels(data)})
    //   //   .pipe(
    //   //     catchError(this.errorService.handleError('item-gl-setup.service  updateGlItem', []))
    //   //   );
    // } else {
    return this.baseService.getHttp(
      action,
      'edit-service',
      `${this.RESTURL}${action}/${data}`)
      // .get(`https://fsconnect-test.mclaneco.com/fs-online-invoicing-ws/rest/v1/itemgl/${action}/${this.serializeModels(data)}`)
      .pipe(map(res => <any[]>res));

    // return this.http.get('https://fsconnect-test.mclaneco.com/fs-online-invoicing-ws/rest/v1/' + this.ITEMS_GL_LIST + '18')
    //   .pipe(map(res => <any[]>res));
    // }

  }

  private serializeModels(data?: any): string {
    console.error(typeof data);
    console.log(data);
    if (data instanceof Object) {
      return `${JSON.stringify([data])}`;
    } else {
      return data;
    }
    //   return data ? `${JSON.stringify([data])}` : '';
  }
}
